import React from 'react';
import {Box, IconButton, Tooltip} from '@mui/material';
import {ChevronLeft, ChevronRight} from '@mui/icons-material';
import {Notification} from 'react-admin';
import {t} from '../../themes/statamicTokens';
import StatamicAppBar from './StatamicAppBar';
import StatamicMenu from './StatamicMenu';
import ScopeSwitcher from './ScopeSwitcher';
import CommandPalette from './CommandPalette';
import {ScopeProvider} from '../../scope/ScopeContext';
import {ThemeModeProvider, useChromeMode} from '../../themes/ThemeModeContext';

const SIDEBAR_WIDTH_EXPANDED = 240;
const SIDEBAR_WIDTH_COLLAPSED = 56;

const CollapseToggle = () => {
    const {chrome, sidebarCollapsed, toggleSidebar} = useChromeMode();
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: sidebarCollapsed ? 'center' : 'flex-end',
                px: sidebarCollapsed ? 0 : 1,
                py: 1,
                borderTop: `1px solid ${chrome.sidebarDivider}`,
                flexShrink: 0,
            }}
        >
            <Tooltip
                title={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
                placement="right"
            >
                <IconButton
                    size="small"
                    onClick={toggleSidebar}
                    sx={{
                        color: chrome.sidebarIcon,
                        '&:hover': {color: chrome.sidebarIconActive, backgroundColor: chrome.sidebarItemHover},
                    }}
                >
                    {sidebarCollapsed
                        ? <ChevronRight sx={{fontSize: 18}}/>
                        : <ChevronLeft sx={{fontSize: 18}}/>}
                </IconButton>
            </Tooltip>
        </Box>
    );
};

const LayoutInner = ({children}) => {
    const {chrome, sidebarCollapsed} = useChromeMode();
    const width = sidebarCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH_EXPANDED;

    return (
        <Box sx={{display: 'flex', height: '100vh', backgroundColor: t.color.page}}>
            <Box
                component="aside"
                sx={{
                    width,
                    flexShrink: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: chrome.sidebarBg,
                    borderRight: `1px solid ${chrome.sidebarBorder}`,
                    overflow: 'hidden',
                    transition: 'width 160ms ease',
                }}
            >
                <ScopeSwitcher/>
                <Box sx={{flex: 1, overflowY: 'auto', overflowX: 'hidden'}}>
                    <StatamicMenu/>
                </Box>
                <CollapseToggle/>
            </Box>

            <Box sx={{display: 'flex', flexDirection: 'column', flex: 1, minWidth: 0}}>
                <StatamicAppBar/>
                <Box
                    component="main"
                    sx={{
                        flex: 1,
                        overflowY: 'auto',
                        backgroundColor: t.color.page,
                    }}
                >
                    {children}
                </Box>
            </Box>

            <Notification/>
            <CommandPalette/>
        </Box>
    );
};

const StatamicLayout = ({children}) => (
    <ThemeModeProvider>
        <ScopeProvider>
            <LayoutInner>{children}</LayoutInner>
        </ScopeProvider>
    </ThemeModeProvider>
);

export default StatamicLayout;
